module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutCountrySelect":{"deselect":"- Vyberte -"}},"en":{"CheckoutCountrySelect":{"deselect":"- Choose - "}}}')
  delete Component.options._Ctor
}
